(ns nosco.ui.messages
  (:require
   [hx.react :refer [defnc]]
   [nosco.react]
   [nosco.icons2 :as icons]))


(defnc SectionMessage [{:keys [title variant children size]}]
  [:div {:class ["nosco-message"
                 (when (= size :small)
                   "nosco-message--small")
                 (case variant
                   :info "nosco-message--informational"
                   :success "nosco-message--success"
                   :warning "nosco-message--warning"
                   :error "nosco-message--critical")]}
   (when (not= size :small)
     [:div {:class ["nosco-message__icon"]}
      [icons/Icon {:icon (case variant
                           :info icons/Info-large
                           :success icons/Check-large
                           :warning icons/Semantic-Warning-large
                           :error icons/Semantic-Error-large)}]])
   [:div
    (when title
      [:div {:class "nosco-message__title"} title])
    [:div {:class "nosco-message__text"}
     children]]])


(defnc Banner [{:keys [variant title text children]}]
  [:div {:class ["nosco-banner2"
                 (when (nil? title)
                   "nosco-banner2--no-title")
                 (case variant
                   :info "nosco-banner2--informational"
                   :success "nosco-banner2--success"
                   :warning "nosco-banner2--warning"
                   :error "nosco-banner2--critical")]}
   (when title
     [:div {:class "nosco-banner2__title"}
      [icons/Icon {:icon (case variant
                           :info icons/Info-large
                           :success icons/Check-large
                           :warning icons/Semantic-Warning-large
                           :error icons/Semantic-Error-large)}]
      title])
   (when text
     [:div {:class "nosco-banner2__text"} text])
   (when children
     [:div {:class "nosco-banner2__actions"}
      children])])

(defnc BannerCompact [{:keys [variant children]}]
  [:div {:class ["nosco-banner2 nosco-banner2--compact"
                 (case variant
                   :info "nosco-banner2--informational"
                   :success "nosco-banner2--success"
                   :warning "nosco-banner2--warning"
                   :error "nosco-banner2--critical")]}
   [:div {:class "nosco-banner2__compact-inner"}
    [:div {:class "nosco-banner2__compact-icon"}
     [icons/Icon {:icon (case variant
                          :info icons/Info-large
                          :success icons/Check-large
                          :warning icons/Semantic-Warning-large
                          :error icons/Semantic-Error-large)}]]

    children]])
